/* CIY product reviews — storefront widget.
   Liquid cannot call an external API at render time, so this fetches
   api.craftityourself.in after load and renders the Figma's Ratings & Reviews,
   Rate this product, and Top Product Reviews blocks.

   The container stays hidden until the API answers, so a network failure or an
   API outage leaves the product page exactly as it was. */
(function () {
  'use strict';

  var API = 'https://api.craftityourself.in';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stars(n, cls) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<span class="ciy-star' + (i <= n ? ' is-on' : '') + (cls ? ' ' + cls : '') +
             '" data-v="' + i + '">★</span>';
    }
    return out;
  }

  function ago(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var days = Math.floor((Date.now() - d.getTime()) / 86400000);
    if (days < 1) return 'today';
    if (days < 30) return days + (days === 1 ? ' day ago' : ' days ago');
    var m = Math.floor(days / 30);
    if (m < 12) return m + (m === 1 ? ' month ago' : ' months ago');
    var y = Math.floor(m / 12);
    return y + (y === 1 ? ' year ago' : ' years ago');
  }

  function summaryHtml(s) {
    if (!s.count) return '';
    var bars = '';
    for (var i = 5; i >= 1; i--) {
      var pct = Math.round((s.histogram[i] / s.count) * 100);
      bars += '<div class="ciy-rating-row">' +
                '<span class="ciy-rating-num">' + i + ' ★</span>' +
                '<span class="ciy-rating-bar"><span style="width:' + pct + '%"></span></span>' +
                '<span class="ciy-rating-pct">' + pct + '%</span>' +
              '</div>';
    }
    return '<p class="ciy-card-heading">Ratings &amp; Reviews</p>' +
      '<div class="ciy-reviews-summary">' +
        '<div class="ciy-reviews-score">' +
          '<span class="ciy-score-num">' + s.average.toFixed(1) + '</span>' +
          '<span class="ciy-review-stars">' + stars(Math.round(s.average)) + '</span>' +
          '<span class="ciy-reviews-count">' + s.count + (s.count === 1 ? ' rating' : ' ratings') + '</span>' +
        '</div>' +
        '<div class="ciy-rating-bars">' + bars + '</div>' +
      '</div>';
  }

  function listHtml(reviews, count) {
    if (!reviews.length) return '';
    var items = reviews.map(function (r) {
      return '<article class="ciy-review" data-id="' + r.id + '">' +
        '<div class="ciy-review-head">' +
          '<strong>' + r.rating.toFixed(1) + '</strong>' +
          '<span class="ciy-review-stars">' + stars(r.rating) + '</span>' +
          '<span class="ciy-review-headline">' + esc(r.headline) + '</span>' +
        '</div>' +
        (r.body ? '<p class="ciy-review-body">' + esc(r.body) + '</p>' : '') +
        '<div class="ciy-review-meta">' +
          (r.verified_buyer ? '<span class="ciy-verified">Verified buyer</span> · ' : '') +
          esc(r.author) + ' — posted ' + ago(r.created_at) +
          '<button type="button" class="ciy-helpful" data-id="' + r.id + '">Helpful (' + r.helpful_up + ')</button>' +
        '</div>' +
      '</article>';
    }).join('');
    return '<p class="ciy-card-heading">Top Product Reviews (' + count + ')</p>' + items;
  }

  function formHtml() {
    return '<div class="ciy-rate-block">' +
      '<p class="ciy-card-heading">Rate this product</p>' +
      '<p class="ciy-rate-sub">Help others make an informed decision!</p>' +
      '<div class="ciy-star-picker" role="radiogroup" aria-label="Your rating">' + stars(0, 'is-pick') + '</div>' +
      '<button type="button" class="ciy-write-review">Write a review</button>' +
      '<form class="ciy-review-form" hidden>' +
        '<input class="ciy-f-name"  type="text"  placeholder="Your name" maxlength="120" required>' +
        '<input class="ciy-f-email" type="email" placeholder="Email (optional)" maxlength="190">' +
        '<input class="ciy-f-head"  type="text"  placeholder="Headline" maxlength="140">' +
        '<textarea class="ciy-f-body" rows="4" placeholder="What did you think?" maxlength="4000"></textarea>' +
        '<button type="submit" class="ciy-submit">Submit review</button>' +
        '<p class="ciy-form-msg" role="status"></p>' +
      '</form>' +
    '</div>';
  }

  function wire(el, productId, reload) {
    var picked = 0;

    var picker = el.querySelector('.ciy-star-picker');
    if (picker) {
      picker.addEventListener('click', function (e) {
        var t = e.target.closest('.ciy-star');
        if (!t) return;
        picked = parseInt(t.getAttribute('data-v'), 10) || 0;
        [].forEach.call(picker.querySelectorAll('.ciy-star'), function (s, i) {
          s.classList.toggle('is-on', i < picked);
        });
        var form = el.querySelector('.ciy-review-form');
        if (form) form.hidden = false;
      });
    }

    var open = el.querySelector('.ciy-write-review');
    if (open) {
      open.addEventListener('click', function () {
        var form = el.querySelector('.ciy-review-form');
        if (form) form.hidden = !form.hidden;
      });
    }

    var form = el.querySelector('.ciy-review-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var msg = form.querySelector('.ciy-form-msg');
        if (!picked) { msg.textContent = 'Please pick a star rating first.'; return; }
        var name = form.querySelector('.ciy-f-name').value.trim();
        if (!name) { msg.textContent = 'Please enter your name.'; return; }

        msg.textContent = 'Sending...';
        fetch(API + '/reviews', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            shopify_product_id: productId,
            rating: picked,
            headline: form.querySelector('.ciy-f-head').value.trim(),
            body: form.querySelector('.ciy-f-body').value.trim(),
            name: name,
            email: form.querySelector('.ciy-f-email').value.trim()
          })
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (d && d.success) { msg.textContent = 'Thanks for your review.'; reload(); }
            else { msg.textContent = (d && d.message) || 'Could not submit. Please try again.'; }
          })
          .catch(function () { msg.textContent = 'Could not submit. Please try again.'; });
      });
    }

    [].forEach.call(el.querySelectorAll('.ciy-helpful'), function (b) {
      b.addEventListener('click', function () {
        b.disabled = true;
        fetch(API + '/reviews/' + b.getAttribute('data-id') + '/vote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ vote: 'up' })
        })
          .then(function (r) { return r.json(); })
          .then(function (d) { if (d && d.counted) reload(); })
          .catch(function () { b.disabled = false; });
      });
    });
  }

  /* The Figma puts a compact rating under the product title (e.g. "3.6 * (6400)").
     That lives in a different block from the reviews section, so it is injected
     here rather than rendered inside #ciy-reviews. Absent when there are no
     reviews, never "0.0 (0)". */
  function titleRating(s) {
    var host = document.querySelector('.product-details .ciy-title-row');
    var old = document.querySelector('.ciy-title-rating');
    if (old) old.remove();
    if (!host || !s.count) return;

    var el = document.createElement('div');
    el.className = 'ciy-title-rating';
    el.innerHTML = '<span class="ciy-tr-score">' + s.average.toFixed(1) + '</span>' +
                   '<span class="ciy-star is-on">★</span>' +
                   '<span class="ciy-tr-count">(' + s.count + ')</span>';
    el.addEventListener('click', function () {
      var target = document.getElementById('ciy-reviews');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    host.insertAdjacentElement('afterend', el);
  }

  function load(el, productId) {
    fetch(API + '/reviews/product/' + encodeURIComponent(productId))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.success) return;
        el.innerHTML = summaryHtml(d.summary) +
                       formHtml() +
                       listHtml(d.reviews, d.summary.count);
        el.hidden = false;
        titleRating(d.summary);
        wire(el, productId, function () { load(el, productId); });
      })
      .catch(function () { /* stays hidden; the rest of the PDP is unaffected */ });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var el = document.getElementById('ciy-reviews');
    if (!el) return;
    var id = el.getAttribute('data-product-id');
    if (id) load(el, id);
  });
})();
